import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Toast } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import {
  getCurrentSlotAsync,
  // getBaseGramPriceAsync,
  // getWithdrawSettingsAsync,
} from '../smartContract/stakeAction'
import { getProfileDashboardAsync, userProfileInfoAsync } from '../Auth/_redux'
import { getErcContract } from '../../../utils/EtheriumHelper'
import { makeStyles } from '@material-ui/core/styles'
import { Tabs, Tab } from 'react-bootstrap'
import { MyBalanceTab } from '../profile_settings/pages/tabs'
import { TokenEstimationTab } from '../profile_settings/pages/tabs/tokenEstimation'
// import Backdrop from "@material-ui/core/Backdrop";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import { ContentRoute } from "../../../_metronic/layout";
// import KYC from '../../modules/Kyc/kyc'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.2) !important',
  },
}))

export function Dashboard() {
  const classes = useStyles()

  const { web3, connected, chainId, address } = useSelector(
    (state) => state.etherium,
    shallowEqual,
  )

  // const { backdrop, currentSlots, increasePrice } = useSelector(
  //   (state) => state.stake,
  //   shallowEqual
  // );

  const { profileDashboard } = useSelector((state) => state.auth)

  const dispatch = useDispatch()

  useEffect(() => {
    if (connected) {
      let ercCntrct = getErcContract(chainId, web3)
      dispatch(getCurrentSlotAsync(ercCntrct, address))
    }
  }, [connected])

  const { user, flashMessage, isLoading } = useSelector(
    (state) => state.auth,
    shallowEqual,
  )

  useEffect(() => {
    dispatch(getProfileDashboardAsync())
    // dispatch(getBaseGramPriceAsync());
    // dispatch(getWithdrawSettingsAsync());
    dispatch(userProfileInfoAsync(user._id))
  }, [])

  const userValuse = {
    emailId: user.emailId,
  }

  const [showA, setShowA] = useState(true)
  const toggleShowA = () => setShowA(!showA)

  return (
    <div className="row">
      {/* message pop up for KYC link begins*/}
      {user.kycStatus !== 'COMPLETED' ? (
        <div className="col-md-12 d-flex justify-content-center">
          <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
            <Toast.Body>
              <h2 className="kyc-toast-title">
                Your KYC is not completed. Please complete it{' '}
                <Link to="/kyc">
                  <span className="text-dark kyc-toast-title-link">here</span>{' '}
                </Link>{' '}
                in order to be able to buy gold.{' '}
              </h2>
            </Toast.Body>
          </Toast>
        </div>
      ) : (
        <div className="col-md-12 d-flex justify-content-center">
          <Toast show={showA} onClose={toggleShowA} className="kyc-toast">
            <Toast.Body>
              <h2 className="kyc-toast-title">
                {' '}
                Click{' '}
                <a
                  href={`http://rfid.victoreanum.com/?uid=${user._id}`}
                  target="_blank"
                >
                  here
                </a>{' '}
                to buy gold.{' '}
              </h2>
            </Toast.Body>
          </Toast>
        </div>
      )}
      {/* message pop up for KYC link ends*/}

      <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap db_1400">
        <div className="mr-1">
          <h5 className="inpg_ttl mr-5">My Account</h5>
          {/* <p className="inpg_p">
            Quisque facilisis mauris eros laoreet laoreet ante faucibus.
          </p> */}
        </div>
      </div>

      <div className="col-md-12 mt-5">
        <Tabs defaultActiveKey="token-estimation" id="ProfileTab" className="def_tab">
          <Tab eventKey="my-balance" title="My Balance">
            <MyBalanceTab profileDashboard={profileDashboard} />
          </Tab>
          <Tab eventKey="account-details" title="Account Details">
            <div className="mt-6 row">
              <div className="col-xl-6">
                <div className="pr_wt_box">
                  <h6>My Gold</h6>
                  <h3 className="text-break">
                    {profileDashboard.goldAcquired} <span>GRAMS</span>
                  </h3>
                </div>
              </div>
              {/* <div className="col-xl-4">
                <div className="pr_wt_box">
                  <h6>Withdrawal Tokens</h6>
                  <h3>{profileDashboard.withdarawTokens}</h3>
                </div>
              </div> */}
              <div className="col-xl-6">
                <div className="pr_wt_box">
                  <h6>My Tokens</h6>
                  <h3>{profileDashboard.availableTokens} </h3>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="token-estimation" title="Token Purchase Estimation">
            <TokenEstimationTab />
          </Tab>
        </Tabs>
      </div>
      {/* <div className="col-md-12 mt-5">
        <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
          <div className="tblmrgn mt-0">
            <Table
              hover
              responsive
              className="mb-0 default_table  with_hoverbtn"
            >
              <thead>
                <tr>
                  <th>Gold ID </th>
                  <th>Total Gold (GRAMS) </th>
                  <th>Used Gold (GRAMS)</th>
                  <th>Available Gold (GRAMS)</th>
                  <th>Cost of Gold/ 1 Gram (USD)</th>
                  <th>Current Value of Tokens</th>
                  <th>Gold Shared With</th>
                  <th className="wd-120"></th>
                </tr>
              </thead>
              <tbody>
                {currentSlots.Gram ? (
                  <tr>
                    <td>{currentSlots.goldPartID}</td>
                    <td>{currentSlots.Gram}</td>
                    <td>{currentSlots.gramsUsed}</td>
                    <td>{currentSlots.availableGold}</td>
                    <td>{increasePrice}</td>
                    <td>{currentSlots.currentToken}</td>
                    <td className="ws_nwrp">
                      {currentSlots.percent && currentSlots.percent.length ? (
                        currentSlots.percent.map((user, i) => {
                          if (i < 4) {
                            return (
                              <img
                                key={user._id}
                                alt=""
                                className={`tuser_img ${i > 0 ? "umlft" : ""}`}
                                src={user.profilePicture}
                              />
                            );
                          }
                          if (i === 4) {
                            return (
                              <span className="more_txt">
                                <h6>{currentSlots.percent.length - 4}</h6>
                                <span>More</span>
                              </span>
                            );
                          }
                          return null;
                        })
                      ) : (
                          <span className="more_txt">
                            <h6>00</h6>
                           
                          </span>
                        )}
                    </td>
                    <td>
                      <Link
                        to="/dashboard/buy"
                        className="btn_new btn-sm dtld_btn"
                      >
                        Buy
                      </Link>
                    </td>
                  </tr>
                ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Record Found
                    </td>
                    </tr>
                  )}
              </tbody>
            </Table>
          </div>
          {backdrop && (
            <div className="basic-verification-loader">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
       */}
      <div className="col-md-12"></div>
      {/* <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color="primary" />
      </Backdrop> */}
    </div>
  )
}
